import currencies from './codes-all.js'
import { map, reduce, filter, has } from 'lodash'

const filteredCurrencies = reduce(filter(currencies, (currency) => {
  return currency.WithdrawalDate == null
}), (result, currency) => {
  if (!has(result, currency.AlphabeticCode)) {
    result[currency.AlphabeticCode] = {
      name: currency.Currency,
      precision: parseInt(currency.MinorUnit, 10),
      code: currency.NumericCode
    }
  }

  return result
}, {})

export default filteredCurrencies



// WEBPACK FOOTER //
// ./shared/lib/ISO4217/index.js